import {
  FETCH_AUDIENCES,
  REMOVE_AUDIENCE,
  ADD_SELECTED_AUDIENCE
} from './mutations-types'
import Audiences from '../../../facebook/Audiences'
import helpers from '../../../helpers/functions'
import moment from 'moment'

export default {
  fetchAudiences ({ commit, dispatch }, payload) {
    dispatch('startSpinner')
    let user = helpers.getCurrentUser()
    // Test
    // const axios = require('axios')
    // axios({
    //   method: 'GET',
    //   url: ``,
    //   params: {
    //     access_token: user.token
    //   }
    // })
    // Test
    const facebook = new Audiences(user, {audience: payload})
    const audiences = []
    return new Promise((resolve, reject) => {
      resolve(facebook.fetchCustomAudiences())
    })
      .then(res => {
        let entities = Object.entries(res)
        entities.forEach(e => {
          if (!isNaN(e[0])) {
            e[1]._data.time_created = moment(e[1]._data.time_created * 1000)._d
            audiences.push(e[1]._data)
          }
        })
        return facebook.fetchSavedAudiences()
      })
      .then(res => {
        let entities = Object.entries(res)
        entities.forEach(e => {
          if (!isNaN(e[0])) {
            e[1]._data.time_created = moment(e[1]._data.time_created)._d
            audiences.push(e[1]._data)
          }
        })
        dispatch('stopSpinner')
        commit(FETCH_AUDIENCES, audiences)
        return audiences
      })
      .catch(err => {
          console.log(err)
        const error = JSON.parse(err.message)
        const response = error.response || {}
        let identifier
        if (response.error_subcode) identifier = response.error_subcode
        else if (response.message) identifier = response.message
        helpers.handleError(error, identifier, 'Facebook: ')
      })
  },
  addAudience ({ commit, dispatch }, payload) {
    dispatch('startSpinner')
    let audienceId = null
    let user = helpers.getCurrentUser()
    const audiences = new Audiences(user, {audience: payload})
    return new Promise((resolve, reject) => {
      resolve(audiences.createCustomAudience())
    })
      .then(res => {
        audienceId = res.audience_id
        return dispatch('fetchAudiences')
      })
      .then(res => {
        const audience = res.find(a => a.id === audienceId)
        commit(ADD_SELECTED_AUDIENCE, audience)
        return true
      })
      .catch(err => {
        const error = JSON.parse(err.message)
        const response = error.response || {}
        let identifier
        if (response.error_subcode) identifier = response.error_subcode
        else if (response.message) identifier = response.message
        helpers.handleError(error, identifier, 'Facebook: ')
      })
  },
  removeAudience ({ commit, dispatch }, payload) {
    let user = helpers.getCurrentUser()
    const audiences = new Audiences(user, {id: payload})
    return new Promise(resolve => {
      resolve(audiences.deleteAudience())
    })
      .then(res => {
        const notification = {
          type: 'success',
          message: ['Audience has been deleted']
        }
        dispatch('showNotification', notification)
        commit(REMOVE_AUDIENCE, payload)
      })
  }
}
